import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: 'app-associate-business-dialog',
	templateUrl: './associate-business-dialog.component.html',
	styleUrl: './associate-business-dialog.component.scss'
})
export class AssociateBusinessDialogComponent {
	activeSelection;

	constructor(@Inject(MAT_DIALOG_DATA) public data: { asset: any, business: any },
	            public readonly dialogRef: MatDialogRef<string>) {
	}

	setActiveSelection($event: any) {
        this.activeSelection = $event;
	}
}
